import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { StaticImage } from "gatsby-plugin-image";
import "swiper/css";
import inc from "../../../images/landing/software-app-development/awards/inc.svg";
import dotcomm from "../../../images/landing/software-app-development/awards/dotcomm.svg";
import clutch from "../../../images/landing/software-app-development/awards/clutch.svg";
import softwareworld from "../../../images/landing/software-app-development/awards/softwareworld.svg";
import topdevelopers from "../../../images/landing/software-app-development/awards/topdevelopers.svg";
import ranwatch from "../../../images/landing/software-app-development/awards/ranwatch.svg";
import horizon from "../../../images/landing/software-app-development/awards/horizon.svg";

function Awardsrecognitionlp() {
  return (
    <section
      className="awards_recognition_lp_software p-100 text_white"
      style={{ background: "#000" }}
    >
      <Container className="awards-container">
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Awards & Recognition</h2>
            <p>
              We thrive on accelerating the path to disruption and implementing
              agile methodology to design, build, deliver, and upscale digital
              solutions. Our future-proof, growth-centric tech has got us
              notorious awards and recognition across industries and regions.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-4"
          >
            <Swiper
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              slidesPerView={7}
              spaceBetween={20}
              // centeredSlides={true}
              loop={true}
              pagination={{
                clickable: true,
              }}
              modules={[Autoplay, Pagination]}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 5,
                },
                1600: {
                  slidesPerView: 7,
                },
              }}
              className="lp-awards-slider"
            >
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/inc.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={inc} alt="inc" />
                  </div>
                  <div className="content">
                    <h5>Inc. 5000</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/dotcomm.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={dotcomm} alt="dotcomm" />
                  </div>
                  <div className="content">
                    <h5>Dot Comm</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/clutch.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={clutch} alt="clutch" />
                  </div>
                  <div className="content">
                    <h5>Clutch</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/softwareworld.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={softwareworld} alt="softwareworld" />
                  </div>
                  <div className="content">
                    <h5>Top Rated</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/topdevelopers.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={topdevelopers} alt="topdevelopers" />
                  </div>
                  <div className="content">
                    <h5>Top Developers</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/ranwatch.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={ranwatch} alt="ranwatch" />
                  </div>
                  <div className="content">
                    <h5>Rank Watch</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/horizon.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={horizon} alt="horizon" />
                  </div>
                  <div className="content">
                    <h5>Horizon</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/inc.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={inc} alt="inc" />
                  </div>
                  <div className="content">
                    <h5>Inc. 5000</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/dotcomm.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={dotcomm} alt="dotcomm" />
                  </div>
                  <div className="content">
                    <h5>Dot Comm</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/clutch.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={clutch} alt="clutch" />
                  </div>
                  <div className="content">
                    <h5>Clutch</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/softwareworld.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={softwareworld} alt="softwareworld" />
                  </div>
                  <div className="content">
                    <h5>Top Rated</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/topdevelopers.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={topdevelopers} alt="topdevelopers" />
                  </div>
                  <div className="content">
                    <h5>Top Developers</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/ranwatch.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={ranwatch} alt="ranwatch" />
                  </div>
                  <div className="content">
                    <h5>Rank Watch</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="awards-box">
                  <div className="awards-img">
                    {/* <StaticImage
                      src="../../../images/landing/software-app-development/awards/horizon.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={228}
                      height={169}
                    /> */}
                    <img src={horizon} alt="horizon" />
                  </div>
                  <div className="content">
                    <h5>Horizon</h5>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Awardsrecognitionlp;
